<template lang="">
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Start Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
<div class="environment-section doc-wrapper doc-inner">
    <div class="row">
        <div class="col-xl-12">
            <div class="environment-wrapper">
                <h2 class="inner-title">App Environment Setup Guide</h2>
                <small class="pb-20">To customize and work on this project, ensure that you have the necessary tools and configurations in place. Follow these steps to set up your development environment:</small>
                <ul class="configure-list">
                    <li class="mb-10"><b>Prerequisites</b>
                        <ol>
                            <li><b>Android Studio/VS Code:</b> Install <a href="https://flutter.dev/docs/get-started/editor?tab=androidstudio" target="_blank" class="redirect-link">Flutter and Dart Plugins</a> in your preferred Integrated Development Environment (IDE), such as Android Studio, Visual Studio Code, or IntelliJ.</li>
                            <li><b>Flutter SDK:</b> Install the latest stable version of <a href="https://flutter.dev/docs/get-started/install" target="_blank" class="redirect-link">Flutter</a> on your system.</li>
                            <li><b>Dart SDK:</b> Ensure the latest stable version of <a href="https://dart.dev/get-dart" target="_blank" class="redirect-link">Dart</a> is installed alongside Flutter.</li>
                            <li><b>Java (JDK):</b> Install <a href="https://www.oracle.com/java/technologies/downloads/#java11" target="_blank" class="redirect-link">java JDK</a> version 11 (LTS) according to your operating system.</li>
                            <div class="row">
                                <div class="col-xl-7">
                                    <a class="img-popup">
                                        <img src="/product/efunding/documentation/assets/images/flutterEnvironmentSetup/environment_setup.webp" alt="nb">
                                    </a>
                                </div>
                            </div>
                        </ol>
                    </li>
                    <li class="mb-10"><b>Project Setup</b>
                        <ol>
                            <li><b>Download and Extract Files :</b>Unzip the project files folder. Inside, you’ll find the source code named as <code>[project name]-app-[version number]</code>.</li>
                            <li><b>Open Project in IDE :</b>Use your preferred IDE (Android Studio, Visual Code, IntelliJ) to open the project.</li>
                        </ol>
                    </li>
                </ul>
                <small class="mb-10">Please run this command:</small>
                <pre class="prettyprint">
                    <code>flutter pub get</code>
                </pre>
            </div>
        </div>
    </div>
</div>
<div class="page-change-area">
    <div class="navigation-wrapper">
        <router-link :to="{ name: 'AdminPanelSetup'}" class="left"><i class="las la-angle-left me-1"></i> Admin Panel Setup</router-link>
        <router-link :to="{ name: 'AppInstallation'}" class="right">App Installation <i class="las la-angle-right ms-1"></i></router-link>
    </div>
</div>
<!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    End Server Requirements Page
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-->
</template>

<script>
export default {
    name: 'FlutterEnvironmentSetupPage',
}
</script>